<template>
    <component :is="tag" class="no-bullet" @keydown="changeFocus">
        <slot />
    </component>
</template>

<script setup>
import { ref, provide, reactive } from 'vue';

const props = defineProps({
    individual: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    tag: {
        type: String,
        default: 'ul',
    },
});

const headers = ref([]);

function registerHeader(headerEl) {
    if (headerEl && !headers.value.includes(headerEl)) {
        headers.value.push(headerEl);
    }
}

function unregisterHeader(headerEl) {
    headers.value = headers.value.filter((el) => el !== headerEl);
}

const accordionListState = reactive({
    registerHeader,
    unregisterHeader,
    headers,
    individual: props.individual,
    disabled: props.disabled,
});

provide('accordionListState', accordionListState);

function changeFocus(event) {
    if (headers.value.includes(document.activeElement)) {
        const key = event.keyCode;
        const ctrlModifier = event.ctrlKey && [33, 34].includes(key);
        const length = headers.value.length;

        if ([38, 40].includes(key) || ctrlModifier) {
            const index = headers.value.indexOf(event.target);
            const direction = [34, 40].includes(key) ? 1 : -1;
            const newIndex = (index + length + direction) % length;
            headers.value[newIndex].focus();
            event.preventDefault();
        } else if ([35, 36].includes(key)) {
            if (key === 36) {
                headers.value[0].focus();
            } else if (key === 35) {
                headers.value[length - 1].focus();
            }
            event.preventDefault();
        }
    }
}
</script>
